import React, { useState } from 'react'
import "./TweetBox.css";
import { Button, Avatar } from '@material-ui/core';
import db from './Firebase';

function TweetBox() {
    const [tweetMessage, setTweetMessage] = useState("");
    const [tweetImage, setTweetImage] = useState("");

    const sendTweet = e => {
        e.preventDefault();

        db.collection('posts').add({
            displayName: 'Ayush',
            username: "ayush",
            verified: true,
            text: tweetMessage,
            image: tweetImage,
            avatar:"https://i7.pngguru.com/preview/386/188/1003/programmer-programming-language-software-developer-computer-programming-sublime-text-computer-cartoon.jpg"
        });

        setTweetMessage("");
        setTweetImage("");
    }

    return (
        <div  className="tweetBox">
            <form >
                <div className="tweetBox__input">
                    <Avatar
                        src="https://i7.pngguru.com/preview/386/188/1003/programmer-programming-language-software-developer-computer-programming-sublime-text-computer-cartoon.jpg"
                    />
                    <input
                        onChange={(e) => setTweetMessage(e.target.value)}
                        value={tweetMessage} 
                        placeholder="what's happening?" 
                        type="text"/>
                </div>
                <input 
                    onChange={(e)=> setTweetImage(e.target.value)}
                    value={tweetImage}
                    className="tweetBox__imageInput" placeholder="Enter image URL" type="text"/>
                <Button onClick={sendTweet} className="tweetBox__button">Tweet</Button>
            </form>
            
        </div>
    )
}

export default TweetBox
